import { Form, Formik, useFormik } from "formik";
import { FC } from "react";
import TextField from "../components/common/TextField";
import Button from "../components/common/Button";
import { ObjectSchema } from "yup";

interface AdminFormProps {
  initialValues: any;
  validationSchema: ObjectSchema<any>;
  onSubmit: (
    values: any,
    formikHelpers: { resetForm: () => void }
  ) => Promise<void>;
  isLoading?: boolean;
}

const AdminForm: FC<AdminFormProps> = ({
  initialValues,
  validationSchema,
  onSubmit,
  isLoading = false,
}) => {
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        isSubmitting,
      }) => {
        return (
          <Form className="mx-auto w-3/5 flex flex-col items-center mt-12 gap-3">
            <TextField
              id="firstname"
              placeholder="Prénom"
              value={values.firstName}
              onChange={handleChange}
              onBlur={handleBlur}
              errors={errors}
              touched={touched}
            />
            <TextField
              id="lastname"
              placeholder="Nom"
              value={values.lastName}
              onChange={handleChange}
              onBlur={handleBlur}
              errors={errors}
              touched={touched}
            />
            <TextField
              id="email"
              placeholder="Email"
              value={values.email}
              onChange={handleChange}
              onBlur={handleBlur}
              errors={errors}
              touched={touched}
            />
            <TextField
              id="password"
              placeholder="Mot de passe"
              value={values.password}
              onChange={handleChange}
              onBlur={handleBlur}
              errors={errors}
              touched={touched}
              hideable
            />
            <Button
              type="submit"
              disabled={isLoading || isSubmitting}
              className="w-1/2 justify-center font-bold py-2 bg-primary rounded text-white mt-4"
            >
              Enregistrer
            </Button>
          </Form>
        );
      }}
    </Formik>
  );
};

export default AdminForm;
